import { CourseLanguage } from './actions';
import { CourseLanguageManagerState } from './reducer';

const selectSlice = (state: any): CourseLanguageManagerState =>
  state.CourseLanguageManager;

export const getLanguageList = (state: any): CourseLanguage[] =>
  selectSlice(state)?.list ?? [];

export const getLanguageLoading = (state: any): boolean =>
  !!selectSlice(state)?.loading;

export const getLanguageSaving = (state: any): boolean =>
  !!selectSlice(state)?.saving;

export const getFilterName = (state: any): string =>
  selectSlice(state)?.filterName ?? '';

export const getModalOpen = (state: any): boolean =>
  !!selectSlice(state)?.modalOpen;

export const getEditingItem = (state: any): CourseLanguage | null =>
  selectSlice(state)?.editing ?? null;
